import { render, staticRenderFns } from "./AccidentIntakePreviousInjuriesForm.vue?vue&type=template&id=7f9afd71&scoped=true"
import script from "./AccidentIntakePreviousInjuriesForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakePreviousInjuriesForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakePreviousInjuriesForm.vue?vue&type=style&index=0&id=7f9afd71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9afd71",
  null
  
)

export default component.exports